<template>
  <div v-if="accommodation" class="topPicksListing__Item">
    <Flare v-if="accommodation.gallery?.length" :srcset="accommodation.gallery[0].image" size="both" width="644" height="455" crop="fill" :alt="accommodation.name" />
    <div class="topPicksListing__ItemContent">
      <div class="topPicksListing__ItemTop">
        <div class="topPicksListing__ItemLocation">
          <img src="/resources/images/icons/location.svg" alt="Location" width="16" height="16" />
          <span><template v-if="accommodation.place.name">{{ accommodation.place.name }}</template><template v-if="accommodation.region.name">, {{ accommodation.region.name }}</template></span>
        </div>
        <div class="topPicksListing__StarsWrapper">
          <img v-for="star in accommodation.category_rating" src="/resources/images/icons/star.svg" width="14" height="14" alt="Star" />
        </div>
      </div>
      <h3 v-text="accommodation.name"></h3>
      <p v-if="accommodation.price">{{ $t('from') }} {{ formatPrice(accommodation.price.price_from, accommodation.price.currency, null, true) }} <template v-if="accommodation.price_from_description">{{ accommodation.price_from_description }}</template></p>
      <p v-else>{{ $t('notAvailable') }}</p>
    </div>
    <nuxt-link v-if="accommodation.sef" :to="accommodation.sef">{{ accommodation.name }}</nuxt-link>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });
  const accommodationsData = useState('accommodationsData');
  const accommodation = computed(() => accommodationsData.value[props.data.accommodation]);
</script>